import { Crumbs } from './bakery/Crumbs';

export enum TrackingEventType {
  HAZARD_ADD_OPEN = 'HAZARD_ADD_OPEN',
  HAZARD_ADD_HAZARD_CLOSED = 'HAZARD_ADD_HAZARD_CLOSED',
  HAZARD_SAVE_CLICKED = 'HAZARD_SAVE_CLICKED',
  HAZARD_SAVE_SUCCESS = 'HAZARD_SAVE_SUCCESS',
  HAZARD_SAVE_FAILURE = 'HAZARD_SAVE_FAILURE',
  HAZARD_DISCARD_OPENED = 'HAZARD_DISCARD_OPENED',
  HAZARD_DISCARD_CANCELLED = 'HAZARD_DISCARD_CANCELLED',
  HAZARD_DISCARD_DISCARDED = 'HAZARD_DISCARD_DISCARDED',
  LOGOUT_CLICKED = 'LOGOUT_CLICKED',
  BORER_HEART_BEAT = 'BORER_HEART_BEAT',
  BAD_AUTH_TOKEN = 'BAD_AUTH_TOKEN',
  MISCONFIGURED_USER = 'MISCONFIGURED_USER',
  ERROR_REMOVING_DATABASE_DURING_LOGOUT = 'ERROR_REMOVING_DATABASE_DURING_LOGOUT',
  REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN',
  UNKNOWN_AUTHENTICATION_ERROR = 'UNKNOWN_AUTHENTICATION_ERROR',
  RESET_APP_DATA_CLICKED = 'RESET_APP_DATA_CLICKED',
  GROUND_CONTROL_SET_SAVED = 'GROUND_CONTROL_SET_SAVED',
  CREATE_LOCATION = 'CREATE_LOCATION',
  UPDATE_LOCATION = 'UPDATE_LOCATION',
  AUTHENTICATION_NETWORK_LOSS = 'AUTHENTICATION_NETWORK_LOSS',
  MTLS_REGISTRATION_SUCCESS = 'MTLS_REGISTRATION_SUCCESS',
}

export interface TrackingEvent {
  type: TrackingEventType;
  blob: Record<string, unknown>;
}

export function crumble(trackingEvent: TrackingEvent): Crumbs {
  return {
    type: trackingEvent.type,
    blob: JSON.stringify(trackingEvent.blob, null, 2),
  };
}
